module.exports = __webpack_public_path__ + "static/media/welcome.4b192855.svg";